export default __webpack_public_path__ + "static/media/volcano.f049ed00.png";